import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { RequestStatus } from '@beef/smart-kit';
import { IMAGE_DATA } from 'constants/detalization';

// Styles
import styles from '../../styles.pcss';

const cx = classNames.bind(styles);

export const SuccessSection = ({ onClick, successText }) => (
  <RequestStatus
    img={{ ...IMAGE_DATA, className: cx('success-icon') }}
    title={successText}
    button={{
      text: 'Ok',
      size: 'm',
      variant: 'main',
    }}
    onConfirm={onClick}
  />
);

SuccessSection.propTypes = {
  onClick: PropTypes.func,
  successText: PropTypes.string,
};
